module.exports = __webpack_public_path__ + "img/link-img.0cdb1c77.svg";